import { useContext } from "react";
import { Box, Button, Typography } from "@mui/material";
import { AppContext } from "../../Context/AppContext";
import { KYC_STATUS } from "../../Constants/kycStatus";
import { setPreviewKycStatus, readKycPreviewFlag } from "../../Constants/kycPreview";

// ⚠️ TEMP DEV-PHASE PREVIEW — NOT production. A floating switch that flips the
// supplier's KYC state while walking the real app, so all three can be seen on
// the real pages rather than on a mock screen. Remove with the AppContext seed.

const OPTIONS = [
  { status: KYC_STATUS.DETAILS_REQUIRED, label: "להשלמת פרטים" },
  { status: KYC_STATUS.PENDING, label: "ממתין לאישור" },
  { status: KYC_STATUS.REJECTED, label: "נדחה" },
  { status: KYC_STATUS.APPROVED, label: "מאושר" },
];

const KycPreviewSwitcher = () => {
  const { kycStatus, setKycStatus } = useContext(AppContext);

  if (!readKycPreviewFlag() || !setKycStatus) return null;

  const pick = (status) => {
    setPreviewKycStatus(status);
    setKycStatus(status);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        insetInlineStart: "16px",
        bottom: "16px",
        zIndex: 1400,
        display: "flex",
        alignItems: "center",
        gap: "6px",
        padding: "8px 10px",
        borderRadius: "12px",
        border: "1px solid rgba(255, 193, 7, 1)",
        backgroundColor: "rgba(255, 244, 229, 1)",
        boxShadow: "0 4px 14px rgba(0, 0, 0, 0.12)",
      }}
    >
      <Typography sx={{ fontSize: "11px", fontWeight: 600, whiteSpace: "nowrap" }}>
        ⚠️ תצוגה: סטטוס KYC
      </Typography>
      {OPTIONS.map((option) => (
        <Button
          key={option.status}
          size="small"
          onClick={() => pick(option.status)}
          sx={{
            minWidth: 0,
            padding: "2px 8px",
            fontSize: "11px",
            borderRadius: "8px",
            color:
              kycStatus === option.status
                ? "rgba(255, 255, 255, 1)"
                : "rgba(62, 63, 76, 0.8)",
            backgroundColor:
              kycStatus === option.status
                ? "rgba(37, 124, 109, 1)"
                : "rgba(255, 255, 255, 1)",
            border: "1px solid rgba(212, 212, 212, 0.9)",
            "&:hover": {
              backgroundColor:
                kycStatus === option.status
                  ? "rgba(37, 124, 109, 1)"
                  : "rgba(245, 245, 245, 1)",
            },
          }}
        >
          {option.label}
        </Button>
      ))}
    </Box>
  );
};

export default KycPreviewSwitcher;
